function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFAF20",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.667 24.333c.792 1.965 2.478 3.334 4.443 3.334 1.967 0 3.651-1.369 4.446-3.334h-8.89zM12.111 33.222v2.222M16.556 32.111l.833 2.222M19.889 27.667l2.222 1.666M7.389 32.111l-.833 2.222M4.333 27.667l-2.222 1.666M17.667 6.556c9.203 0 16.666 7.386 16.666 16.5v20.166"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.154 9.974V5.487a4.488 4.488 0 0 0-8.975 0v4.487A11.66 11.66 0 0 0 1 20.744v3.59h23.333v-3.59c0-4.856-2.965-9.012-7.18-10.77zM41 43.222H26.556"
}));

var SvgLightFixtureIcon = function SvgLightFixtureIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightFixtureIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/light_fixture_icon.080e615d.svg";
export { ForwardRef as ReactComponent };